import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { StoreGet, StoreSet } from "@/types";
import { IUserPropertyStore } from "./type";
import { composeMiddleware } from "../middleware";
import { UserPropertyAPI } from "./services";
import { commonActions } from "../common";

export const initialUserPropertyState = () => {
  return {
    userProperty: {
      isReRegister: null,
      picRechargeOver: null,
      isFirstRecharge: null,
      isFocusOnWX: null,
      isBindMiniPro: null,
      isRealName: null,
      isSubmitTask: null, //是否提交过作业
      animationNewUserRegister: null,
      animationInviteCount: null,
    },
  };
};

const actions = (
  set: StoreSet<IUserPropertyStore>,
  get: StoreGet<IUserPropertyStore>
) => ({
  ...commonActions(set, get),
  fetchUserProperty: async () => {
    const { userProperty } = get();
    if (userProperty.isReRegister !== null) return;
    const { data } = await UserPropertyAPI.getUserProperty();
    set({
      userProperty: data ?? userProperty,
    });
  },
});

export const useUserPropertyStore = create<IUserPropertyStore>()(
  composeMiddleware(
    [devtools, immer],
    (set: StoreSet<IUserPropertyStore>, get: StoreGet<IUserPropertyStore>) => ({
      ...initialUserPropertyState(),
      ...actions(set, get),
    })
  )
);
